<template>
  <v-select
    :items="templateList"
    item-value="id"
    item-text="name"
    v-model="idValue"
    label="Email Template"
    :readonly="readonly"
    :rules="[requiredCheck()]"
    outlined
    dense
  ></v-select>
</template>

<script>
import { mapActions } from 'vuex'
import { required } from '@/lib/formValidations'

// Self-contained (not backed by the shared workflowEmailTemplates list module) so this dropdown
// doesn't fight WorkflowEmailTemplateList.vue over the same list state when both are mounted.
export default {
  props: [
    'id',
    'clientId',
    'isRequired',
    'readonly'
  ],
  data () {
    return {
      templateList: []
    }
  },
  computed: {
    idValue: {
      get () {
        return this.id
      },
      set (newValue) {
        this.$emit('templateIdChange', newValue)
      }
    }
  },
  watch: {
    clientId () {
      this.loadTemplates()
    }
  },
  methods: {
    ...mapActions('workflowEmailTemplates', ['getActiveWorkflowEmailTemplateOptions']),
    requiredCheck () {
      return !this.isRequired || required('Email Template')
    },
    loadTemplates () {
      const filters = { isActive: true }
      if (this.clientId) filters.clientId = this.clientId
      this.getActiveWorkflowEmailTemplateOptions(filters)
        .then(templates => { this.templateList = templates })
    }
  },
  created () {
    this.loadTemplates()
  }
}
</script>
